export default "__VITE_ASSET__D8Va_UDU__"